export default class Contratto{
    CodiceContratto;
    DataContratto;
    Stato;
    Descrizione;
    DataInizioValidita;
    validita;
    DataFineValidita;
    DataScadenzaPreavviso;
    TipoScadenza;
    CodiceStato;
    Revisione;
    CodiciSito;
    
    constructor(){}
}